function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDomesticMapRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 2h-4a2 2 0 00-2 2v4h8V4a2 2 0 00-2-2zM22 17h-9v6h10v7h5a2 2 0 002-2V10h-8v7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30h6v-5h-8v3a2 2 0 002 2zM2 17v4a2 2 0 002 2h1v5a2 2 0 002 2h2a2 2 0 002-2V17H2zM7 4a2 2 0 00-2-2H4a2 2 0 00-2 2v3h5V4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10H2v2h10V2h-2v8z",
    fill: props.color
  }));
}

export default SvgIconDomesticMapRexFilled;